import { useEffect, useState } from "react";
import { SlArrowDown, SlArrowUp } from "react-icons/sl";
import { PiCheck } from "react-icons/pi";
import Search from "../assets/icons/search.svg";
import { AiOutlineEye } from "react-icons/ai";
import book from "../assets/icons/openBook.svg";
import notice from "../assets/icons/notice.svg";
import advert from "../assets/icons/advert.svg";
import Modal from "../components/modals/Modal";
import GalleryModal from "../components/modals/GalleryModal";
import Advertisement from "../components/modals/Advertisement";
import Brochure2Modal from "../components/modals/Brochure2Modal";
import title_icon1 from "../assets/icons/advert_icon1.svg";
import advertisement1 from "../assets/images/advertisement1.png";
import advertisement2 from "../assets/images/advertisement2.png";
import { polyMonoData } from "../data/brochre2Data.js/polyMonoData";
import { collegesData } from "../data/brochre2Data.js/collegesData";
// import { innovationEntData } from '../data/brochre2Data.js/innovationEntData';
import { degreeAwardingData } from "../data/brochre2Data.js/degreeAwardingData";
import ContentModals from "../components/modals/ContentModals";
import DashboardLayout from "./DashboardLayout";

const Brochure2 = () => {
  const [modal, setModal] = useState(false);
  const [contentModal, setContentModal] = useState(false);
  const [advertModal, setAdvertModal] = useState(false);
  const [showInst, setShowInst] = useState(false);
  const [inst, setInst] = useState("All");
  const [data, setData] = useState([]);

  const [filterLetter, setFilterLetter] = useState([]);
  const [showFilter, setShowFilter] = useState(false);

  const [searchTerm, setSearchTerm] = useState("");

  const handleInst = (item) => {
    setInst(item.categoryTitle);
    setData(item);
    setShowInst(false);
    setShowFilter(false);
  };

  const application = [
    {
      id: 1,
      title: "ADVERTISEMENT",
      title_icon: title_icon1,
      images: [
        {
          id: 1,
          img: advertisement1,
        },
        {
          id: 2,
          img: advertisement2,
        },
      ],
      img_alt: "entry_image",
    },
  ];

  // JOIN ALLL DATA TOGETHER
  const combinedData = [
    ...degreeAwardingData,
    ...collegesData,
    // ...innovationEntData,
    ...polyMonoData,
  ];

  // JOIN ALLL DATA TOGETHER AND MAP THEM
  const contentNames = combinedData.flatMap((category) =>
    category.contentSection.map((content) => content)
  );

  const handleSearch = (e) => {
    const searchValue = e.target.value.toLowerCase();
    setSearchTerm(searchValue);
    setShowFilter(true);
    const filteredSchools = contentNames.filter((item) =>
      item.contentSectionName
        .toLowerCase()
        .startsWith(searchValue.toLowerCase())
    );
    setFilterLetter(filteredSchools);
  };

  useEffect(() => {}, [contentNames, data, searchTerm, showFilter, inst]);

  return (
    <DashboardLayout
      brochure="Brochure by programme"
      childTab={12}
      animated={true}
    >
      <div className="flex flex-col items-center justify-start w-full px-5 pb-7 mt-6 md:px-6 lg:relative lg:px-7 lg:mt-0 xl:px-10 xl:pb-10">
        <div className="flex items-center justify-start w-full flex-wrap md:relative md:justify-end">
          <div className="flex items-center justify-start w-[50%] cursor-pointer mt-5 md:w-[145px] md:justify-start lg:mt-0 lg:w-[160px] xl:w-[180px]">
            <img className="w-4 xl:w-5" src={book} alt="open_book_icon" />
            <p className="text-[10px] font-medium ml-2 text-[#53545C] lg:text-[11px] lg:font-semibold xl:text-xs">
              INTRODUCTORY NOTE
            </p>
          </div>

          <div className="flex items-center justify-start w-[50%] cursor-pointer mt-5 md:w-[135px] md:justify-start lg:mt-0 lg:w-[150px] xl:w-[165px]">
            <img className="w-4 xl:w-5" src={notice} alt="open_book_icon" />
            <p className="text-[10px] font-medium ml-2 text-[#53545C] lg:text-[11px] lg:font-semibold xl:text-xs">
              IMPORTANT NOTICE
            </p>
          </div>

          <div
            onClick={() => setAdvertModal(true)}
            className="flex items-center justify-start w-[50%] cursor-pointer mt-5 md:w-[115px] md:justify-start lg:mt-0 lg:w-[120px] xl:w-[125px]"
          >
            <img className="w-4 xl:w-5" src={advert} alt="open_book_icon" />
            <p className="text-[10px] font-medium ml-2 text-[#53545C] lg:text-[11px] lg:font-semibold xl:text-xs">
              ADVERTISEMENT
            </p>
          </div>
        </div>

        {/*TOP INPUTS* */}
        <div className="flex items-start justify-between w-full mt-8 flex-wrap md:absolute md:px-6 md:z-10 md:mt-16 lg:px-7 xl:px-10 xl:mt-20">
          {/*INSTITUITION* */}
          <div className="flex flex-col items-start w-full bg-white md:w-[58%] xl:w-[63%]">
            <p className="text-[11px] text-[#101828] font-medium xl:text-sm">
              Institution
            </p>
            <div className="flex flex-col items-center w-full py-[10px] px-3 mt-1 border-[1px] border-[#DDE1E6] rounded-md xl:py-3 xl:px-5 xl:rounded-lg">
              <div
                onClick={() => setShowInst(!showInst)}
                className="flex items-center justify-between w-full"
              >
                <p className="text-[10px] text-[#101828] font-normal xl:text-sm">
                  {inst ? inst : "All"}
                </p>
                {showInst ? (
                  <SlArrowUp className="text-xs text-[#808080] ml-5 xl:text-sm" />
                ) : (
                  <SlArrowDown className="text-xs text-[#808080] ml-5 xl:text-sm" />
                )}
              </div>
              {showInst && (
                <div className="w-full">
                  {combinedData.map((item) => (
                    <div
                      key={item.id}
                      onClick={() => handleInst(item)}
                      className="flex items-start justify-start w-full mt-3 md:items-center cursor-pointer"
                    >
                      <div className="flex items-center justify-center h-[14px] w-[14px] rounded-sm border-[1px] border-[#DDE1E6] xl:h-4 xl:w-4 xl:rounded">
                        {inst === item.categoryTitle && <PiCheck />}
                      </div>
                      <p className="text-[10px] text-[#101828] font-normal ml-2 xl:text-sm">
                        {item.categoryTitle}
                      </p>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>

          {/*SEARCH*/}
          <div className="flex flex-col items-start mt-4 w-full bg-white md:w-[40%] md:mt-0 xl:w-[35%]">
            <p className="text-[11px] text-[#101828] font-medium xl:text-sm">
              Search
            </p>
            <div className="relative h-9  mt-1 w-full xl:h-11">
              <input
                className="border-[1px] rounded-md border-[#DDE1E6] h-full w-full bg-white text-[10px] text-[#101828] font-normal pl-9 outline-[#25A249] 
                                      xl:text-sm xl:pl-12 xl:rounded-lg"
                placeholder="Search institution name"
                value={searchTerm}
                onChange={handleSearch}
              />
              <img
                className="absolute left-3 top-[10px] w-[14px] xl:w-4 xl:top-[14px] xl:left-5"
                src={Search}
                alt="search_icon"
              />
            </div>
          </div>
        </div>

        <div className="flex items-start justify-between w-full mt-9 md:items-center md:mt-36 lg:mt-40 xl:mt-48">
          <p className="text-[12px] font-semibold text-[#53545C] mr-6 md:text-[13px] xl:text-base">
            {inst ? inst : "All"}
          </p>

          <div className="flex items-center justify-end">
            <p className="text-[10px] font-semibold text-[#53545C] md:text-[11px] xl:text-[13px]">
              Show
            </p>
            <div className="flex items-center justify-between px-[6px] py-[3px] border-[1px] border-[#DDE1E6] rounded mx-[6px] md:mx-2 xl:mx-3">
              <p className="text-[10px] font-semibold text-[#53545C] md:text-[11px] xl:text-[13px]">
                12
              </p>
              <SlArrowDown className="text-[7px] ml-[10px] xl:ml-[14px] xl:text-[9px]" />
            </div>
            <p className="text-[10px] font-semibold text-[#53545C] md:text-[11px] xl:text-[13px]">
              entries
            </p>
          </div>
        </div>

        {/*INSTTUITIONS AND COURSES*/}
        <div className="flex flex-col items-start justify-start w-full mt-3 lg:mt-0 xl:mt-1">
          {/*LISTS CONTENTS UNDER EACH CATEGORY*/}
          {inst !== "All" &&
            !showFilter &&
            data.contentSection.map((item) => {
              return (
                <div
                  key={item.id}
                  className="flex items-start justify-between w-full mt-6 border-b-[1px] border-[#DDE1E6] pb-3 md:flex-row md:items-start md:w-full md:mt-10 lg:items-center lg:mt-8 xl:pb-4"
                >
                  <p className="text-[11px] font-medium text-[#53545C] w-[65%] mr-3 md:text-[11px] xl:text-[13px]">
                    {item.pageTile
                      ? `${item.contentSectionName} (${item.pageTile})`
                      : item.contentSectionName}
                  </p>

                  <div
                    onClick={() =>
                      item.contentSectionName === "List of Schools" ||
                      item.contentSectionName === "All Institutions"
                        ? setModal(item)
                        : item.contentFile
                        ? setContentModal(item)
                        : setModal(false)
                    }
                    className="flex items-center justify-between px-3 h-8 cursor-pointer rounded-md bg-[#25A249] md:mt-0 md:ml-3  md:px-3 xl:px-[15px] xl:h-9"
                  >
                    <p className="text-[10px] font-medium mr-1 w-full text-[#ffffff] md:text-[10px] xl:text-[13px]">
                      View details
                    </p>
                    <AiOutlineEye className="text-white text-lg xl:text-xl" />
                  </div>
                </div>
              );
            })}

          {/*LISTS DEFAULT CONTENTS*/}
          {inst === "All" &&
            !showFilter &&
            contentNames.map((item) => {
              return (
                <div
                  key={item.id}
                  className="flex items-start justify-between w-full mt-6 border-b-[1px] border-[#DDE1E6] pb-3 md:flex-row md:items-start md:w-full md:mt-10 lg:items-center lg:mt-8 xl:pb-4"
                >
                  <p className="text-[11px] font-medium text-[#53545C] w-[65%] mr-3 md:text-[11px] xl:text-[13px]">
                    {item.pageTile
                      ? `${item.contentSectionName} (${item.pageTile})`
                      : item.contentSectionName}
                  </p>

                  <div
                    onClick={() =>
                      item.contentSectionName === "List of Schools" ||
                      item.contentSectionName === "All Institutions"
                        ? setModal(item)
                        : item.contentFile
                        ? setContentModal(item)
                        : setModal(false)
                    }
                    className="flex items-center justify-between px-3 h-8 cursor-pointer rounded-md bg-[#25A249] md:mt-0 md:ml-3  md:px-3 xl:px-[15px] xl:h-9"
                  >
                    <p className="text-[10px] font-medium mr-1 w-full text-[#ffffff] md:text-[10px] xl:text-[13px]">
                      View details
                    </p>
                    <AiOutlineEye className="text-white text-lg xl:text-xl" />
                  </div>
                </div>
              );
            })}

          {/*SEARCH CONTENTS DATA*/}
          {showFilter &&
            filterLetter.map((item) => {
              return (
                <div
                  key={item.id}
                  className="flex items-start justify-between w-full mt-6 border-b-[1px] border-[#DDE1E6] pb-3 md:flex-row md:items-start md:w-full md:mt-10 lg:items-center lg:mt-8 xl:pb-4"
                >
                  <p className="text-[11px] font-medium text-[#53545C] w-[65%] mr-3 md:text-[11px] xl:text-[13px]">
                    {item.pageTile
                      ? `${item.contentSectionName} (${item.pageTile})`
                      : item.contentSectionName}
                  </p>

                  <div
                    onClick={() =>
                      item.contentSectionName === "List of Schools"
                        ? setModal(item)
                        : item.contentFile
                        ? setContentModal(item)
                        : setModal(false)
                    }
                    className="flex items-center justify-between px-3 h-8 cursor-pointer rounded-md bg-[#25A249] md:mt-0 md:ml-3  md:px-3 xl:px-[15px] xl:h-9"
                  >
                    <p className="text-[10px] font-medium mr-1 w-full text-[#ffffff] md:text-[10px] xl:text-[13px]">
                      View details
                    </p>
                    <AiOutlineEye className="text-white text-lg xl:text-xl" />
                  </div>
                </div>
              );
            })}

          {/* FILTERED SCHOOLS NOT FOUND */}
          {filterLetter.length === 0 && showFilter && (
            <div className="flex items-center justify-center w-full">
              <p className="text-[#25A249] font-medium">
                Filtered items not found...
              </p>
            </div>
          )}
        </div>

        {/*MODAL*/}
        {modal && (
          <Modal onClick={() => setModal(false)}>
            <Brochure2Modal setModal={setModal} data={modal} />
          </Modal>
        )}

        {/*CONTENT MODAL*/}
        {contentModal && (
          <Modal onClick={() => setContentModal(false)}>
            <ContentModals setModal={setContentModal} data={contentModal} />
          </Modal>
        )}

        {/*ADVERT MODAL*/}
        {advertModal && (
          <GalleryModal onClick={() => setAdvertModal(false)}>
            {application.map((item) => {
              return <Advertisement setModal={setAdvertModal} data={item} />;
            })}
          </GalleryModal>
        )}
      </div>
    </DashboardLayout>
  );
};

export default Brochure2;
